
import { defineComponent, SetupContext } from "vue";
import NativeClient from "@/client/native-client";
export default defineComponent({
  name: "CommonRecipeFoodIdItem",
  props: {
    /**
     * 画像URL
     */
    icon: {
      type: String,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const onImageError = (event: Event) =>{
      NativeClient.sendDebugLog("CommonRecipeFoodIdItem onImageError");
      if (event.target) {
        NativeClient.sendDebugLog("CommonRecipeFoodIdItem onImageError target exist");
        (event.target as HTMLImageElement).src = require("@/assets/images/food_noimage.png");
      }
    };
    return {
      onImageError
    }
  }
});
